import { Compose } from 'provider-compose'
import CatalogItem from './catalogItem'
import Checkout from './checkout'
import Country from './country'
import Discount from './discount'
import Order from './order'
import Upsell from './upsell'
import Lead from './lead'

interface Props {
  children: React.ReactNode
}

const providers = [
  Checkout.Provider,
  Lead.Provider,
  Order.Provider,
  Country.Provider,
  Upsell.Provider,
  Discount.Provider,
  CatalogItem.Provider,
]

const Store: React.FC<Props> = ({ children }) => (
  <Compose providers={providers}>{children}</Compose>
)

export { Store, CatalogItem, Checkout, Country, Discount, Order, Upsell }
